import FormatsStrings from "./FormatsStrings";

export default {
    mixins: [FormatsStrings],

    methods: {
        incompleteStatuses() {
            return ['step1', 'step2', 'step3'];
        },

        notEnrolledStatuses() {
            return ['sent_agreement', 'not_enrolled'];
        },

        unenrolledStatuses() {
            return this.incompleteStatuses().concat(this.notEnrolledStatuses());
        },

        isIncomplete(status) {
            return this.incompleteStatuses().includes(status);
        },

        isNotEnrolled(status) {
            return this.notEnrolledStatuses().includes(status);
        },

        isUnenrolled(status) {
            return this.unenrolledStatuses().includes(status);
        },

        isEnrolled(status) {
            return status === 'enrolled';
        },

        formatEnrollmentStatus(value) {
            if (value === 'sent_agreement') {
                return 'Enrollment Material Sent';
            } else if (this.isIncomplete(value)) {
                return 'Incomplete';
            }
            return this.stringFormat(value);
        }
    },
}